import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Link,
  Paper,
  TextField,
  Typography,
  styled,
  useTheme,
} from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { memo, useEffect, useState } from "react";
import {
  claimIndicatorList,
  getBothSignalData,
  getHeaderSignalValuesFromArray,
  getHeaderValues,
  getLatLongList,
  receivedAllFourCoordinates,
  selectedStringListValues,
} from "../../utility/helper";
import { useLocation, useNavigate } from "react-router";

import CdadHeaderTopFilterComponent from "./components/CdadHeaderTopFilterComponent";
import CdadHeaderCenterFilterComponent from "./components/CdadHeaderCenterFilterComponent";
import { headerDataTableHeaders } from "../../utility/constants";
import { useStyles } from "./style";
import { linkCdadFilterAttributes, linkCdadFilterAttributes51F, linkCdadFilterAttributesCan, linkCdadFilterAttributesVins, linkCdadMapFilterAttributes } from "assets/DataFile/headerPageData";
dayjs.extend(utc);

const HeadersPageRevised = () => {
  console.log('test')
  const theme = useTheme();
  const style = useStyles();
  const routeLocation = useLocation();
  const { id, jobName, linkCdadFilterAttributesData, linkCdadMapFilterAttributesData, linkCdadFilterAttributesDataVins, linkCdadFilterAttributesDataCan, linkCdadFilterAttributesData51F } = routeLocation.state;
  const [data, setData] = useState(linkCdadFilterAttributesData?.available_attributes ?? []);
  const [mapData, setMapData] = useState(linkCdadMapFilterAttributesData?.mapView_data ?? []);
  const [vinData, setVinData] = useState(linkCdadFilterAttributesDataVins?.available_attributes ?? []);
  const [canData, setCanData] = useState(linkCdadFilterAttributesDataCan?.available_attributes ?? []);
  const [fiftyOneFData, setFiftyOneFData] = useState(linkCdadFilterAttributesData51F?.available_attributes ?? []);
  const [unNestedParamData, setUnNestedParamData] = useState([]);
  const [unNestDataEnable, setunNestDataEnable] = useState(true);
  const [vinListFromFile, setVinListFromFile] = useState([]);
  const [goeCoordinates, setGoeCoordinates] = useState([]);
  const [goeBondValue, setGoeBondValue] = useState("");
  const [isLatLangNotValid, setisLatLangNotValid] = useState<boolean>(false);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [unnestingJobName, setUnnestingJobName] = useState<string>('');
  console.log(linkCdadFilterAttributesData, linkCdadMapFilterAttributesData, linkCdadFilterAttributesDataVins, linkCdadFilterAttributesDataCan, linkCdadFilterAttributesData51F)
  useEffect(() => {
    generateTriggerObject();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const navigate = useNavigate();
  useEffect(() => {
    if (linkCdadFilterAttributes?.available_attributes?.length > 0) {
      setData(linkCdadFilterAttributes?.available_attributes);
    }
    if (linkCdadFilterAttributes51F?.available_attributes?.length > 0) {
      setFiftyOneFData(linkCdadFilterAttributes51F?.available_attributes);
    } 
    if (linkCdadFilterAttributesCan?.available_attributes?.length > 0) {
      setCanData(linkCdadFilterAttributesCan?.available_attributes);
    } 
    if (linkCdadFilterAttributesVins?.available_attributes?.length > 0) {
      setVinData(linkCdadFilterAttributesVins?.available_attributes);
    } 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [linkCdadFilterAttributes, id, linkCdadFilterAttributes51F, linkCdadFilterAttributesCan, linkCdadFilterAttributesVins]);

  useEffect(() => {
    if (linkCdadMapFilterAttributes?.mapView_data?.length > 0) {
      setMapData(linkCdadMapFilterAttributes?.mapView_data);
    } 
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [linkCdadMapFilterAttributes, id]);


  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#D9D9D9",
      color: "#000000",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledLinkText = styled(TableRow)(({ theme }) => ({
    color: "#42A5F5",
  }));
  const HeaderDatatable = (props: any) => {
    const [dialogName, setDialogName] = useState("");
    const [showDialogData, setShowDialogData] = useState<string[]>([]);

    return (
      <>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                {props?.headData.map((item: any, index: number) => {
                  return (
                    <StyledTableCell key={index}>{item.label}</StyledTableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {props?.data?.map((item: any, index: number) => {
                return (
                  <TableRow
                    key={index}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {item?.vehicleName}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {item?.ModelYear}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {item?.DispatchModelType}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <Link
                        component="button"
                        underline="none"
                        variant="body1"
                        onClick={() => {
                          if(props?.vinList) {
                            setShowDialogData(selectedStringListValues(props?.vinList));
                            setDialogName("VINs (Read Only)");
                          } 
                        }}
                      >
                        <StyledLinkText>
                          {props?.vinList?.length > 0 ? selectedStringListValues(props?.vinList)?.length : 0 }
                        </StyledLinkText>
                      </Link>
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <Link
                        component="button"
                        underline="none"
                        variant="body1"
                        onClick={() => {
                          setShowDialogData(getHeaderSignalValuesFromArray("can_signals", [canData[index]]));
                          setDialogName("CAN (Read Only)");
                        }}
                      >
                        <StyledLinkText>
                          {canData[index]?.can_signals[0]?.length}
                        </StyledLinkText>
                      </Link>
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <Link
                        component="button"
                        underline="none"
                        variant="body1"
                        onClick={() => {
                          setShowDialogData(getHeaderSignalValuesFromArray("51f_signals", [fiftyOneFData[index]]));
                          setDialogName("51F (Read Only)");
                        }}
                      >
                        <StyledLinkText>
                          {fiftyOneFData[index]?.['51f_signals'][0]?.length}
                        </StyledLinkText>
                      </Link>
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {item?.min_timestamp}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {item?.max_timestamp}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <Dialog
          aria-labelledby="customized-dialog-title"
          open={showDialogData?.length > 0}
        >
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
            {dialogName}
          </DialogTitle>
          <IconButton
            aria-label="close"
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
            onClick={() => {
              setShowDialogData([]);
              setDialogName("");
            }}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent>
            <ModalData showDialogData={showDialogData} />
          </DialogContent>
          <DialogActions>
            <Button
              autoFocus
              variant="outlined"
              onClick={() => {
                setShowDialogData([]);
                setDialogName("");
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  };

  const ModalData = (props: any) => {
    return (
      <Box sx={{ flexGrow: 1 }}>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          {props?.showDialogData &&
            props?.showDialogData?.map((item: any, index: number) => {
              return (
                <Grid item xs={4} key={index}>
                  <Item>{item}</Item>
                </Grid>
              );
            })}
        </Grid>
      </Box>
    );
  };

  const generateTriggerObject = (attributes?: any) => {
    let datas: any = unNestedParamData;
    let existingList = datas?.filter(
      (item: any) => item?.title === attributes?.title
    );
    if (datas?.length > 0) {
      if (existingList?.length > 0) {
        datas?.forEach((item: any, index: number) => {
          if (item?.title === attributes?.title) {
            datas[index] = { ...attributes };
          }
        });
      } else {
        datas.push(attributes);
      }
    } else {
      datas.push(attributes);
    }
    const signalData = datas?.filter(
      (item: any) =>
        (item?.title?.indexOf("51F") > 0 && item?.value?.length > 0) ||
        (item?.title?.indexOf("Can") > 0 && item?.value?.length > 0)
    );
    setunNestDataEnable(signalData?.length <= 0);
    return setUnNestedParamData(datas);
  };

  const updateList = (filterData: any) => {
    let attributes: any = [];
    if (filterData?.value) {
      attributes.push(filterData);
    }
    if (attributes?.length > 0) {
      generateTriggerObject(attributes[0]);
    }
  };

  const checkLinkFilter = async () => {
    if (unNestedParamData && unNestedParamData?.length > 0) {
      let linkData = [...unNestedParamData];
      linkData?.forEach((item: any, index: number) => {
        if (
          item?.title === "vins" ||
          item?.title === "list_CanLabels" ||
          item?.title === "list_51FLabels"
        ) {
          linkData.splice(index, 1);
        }
      });
    }
  };

  const resetSignalSelection = () => {
    if (unNestedParamData?.length > 0) {
      unNestedParamData.forEach((element: any, index: number) => {
        if (
          element?.title === "list_CanLabels" ||
          element?.title === "list_51FLabels"
        ) {
          unNestedParamData.splice(index, 1);
        }
      });
    }
    setunNestDataEnable(true);
  };
  const vinListUpdate = () => {
    let data: any = [...unNestedParamData];
    let newVinList: any = [];
    if (vinListFromFile?.length > 0) {
      if (unNestedParamData?.length > 0) {
        const vinLists: any = unNestedParamData?.filter(
          (item: any) => item?.title === "vins"
        );
        if (vinLists?.length > 0) {
          newVinList = getBothSignalData(vinLists[0]?.value, vinListFromFile);
          data?.forEach((item: any, index: number) => {
            if (item?.title === "vins") {
              data[index].value = newVinList;
            }
          });
        } else {
          const dataValue = {
            title: "vins",
            value: vinListFromFile,
          };
          data.push(dataValue);
        }
      } else {
        const dataValue = {
          title: "vins",
          value: vinListFromFile,
        };
        data.push(dataValue);
      }
    }

    if (receivedAllFourCoordinates(goeCoordinates)) {
      const latLongList = getLatLongList(goeCoordinates);
      const latitudeData = {
        title: "latitudes",
        value: latLongList?.lat,
      };
      const longitudeData = {
        title: "longitudes",
        value: latLongList?.long,
      };
      const boundData = {
        title: "Type",
        value: goeBondValue,
      };
      data.push(latitudeData);
      data.push(longitudeData);
      data.push(boundData);
    }

    const jobTypeElement = {
      title: "job_type",
      value: "Un-Nested Data",
    };
    data.push(jobTypeElement);
    const jobNameElement = {
      title: "job_name",
      value: unnestingJobName,
    };
    data.push(jobNameElement);
    return removeEmptyValues(data);
  };

  console.log(vinListUpdate())

  function removeEmptyValues(data: any[]) {
    return data.filter((item: { value: string | any[]; }) => item?.value && item?.value?.length !== 0);
  }

  const triggerUnNestedDataJob = async () => {
    console.log('unnest job')
  };

  const setVinListFile = (vinList: any) => {
    setVinListFromFile(vinList);
  };

  const updategeoFilterCoordinates = (value: any) => {
    setGoeCoordinates(value);
  };

  const updateGeoFilterBondValue = (value: string) => {
    setGoeBondValue(value);
  };

  const updateUnNestDataEnable = (value: any) => {
    // Update unNestDataEnable in the parent component
    setunNestDataEnable(value);
  };

  return (
    <div>
      <div>
        <Box
          sx={{
            fontWeight: "bold",
            minHeight: `50px`,
            display: "flex",
            justifyContent: "space-between"
          }}
        >
          <Typography
            fontWeight="bold"
            variant="h5"
            color={theme.palette.primary.contrastText}
          >
            {"Header Data"}
          </Typography>
        </Box>
        <Paper
          elevation={2}
          sx={{
            marginTop: "10px",
            padding: 1,
          }}
        >
          <div>
            {false ? (
              <div className={style.overlay}>
                <div className={style.loader}></div>
              </div>
            ) : (
              <div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <div style={{ paddingBottom: "16px" }}>
                    <Typography fontWeight="bold" variant="body1">
                      {`Job Name: ${jobName}`}
                    </Typography>
                    <Typography fontWeight="bold" variant="body1">
                      {`Job ID: ${id}`}
                    </Typography>
                  </div>
                
                </div>
                <div>
                  <div id="headerDataFilteContainer">
                  <div style={{ paddingBottom: "16px" }}>
                      <CdadHeaderTopFilterComponent
                        data={data}
                        vinList={getHeaderValues("vin", vinData)}
                      />
                    </div>
                    <div style={{ paddingTop: "16px" }}>
                      <CdadHeaderCenterFilterComponent
                        vinList={getHeaderValues("vin", vinData)}
                        canSignalData={getHeaderSignalValuesFromArray(
                          "can_signals",
                          canData
                        )}
                        FiftyOneSignalData={getHeaderSignalValuesFromArray(
                          "51f_signals",
                          fiftyOneFData
                        )}
                        getUpdatedList={updateList}
                        data={data}
                        resetSignalSelection={resetSignalSelection}
                        vinListFile={setVinListFile}
                        checkLinkFilter={checkLinkFilter}
                        geoFilterCoordinates={updategeoFilterCoordinates}
                        geoFilterBondValue={updateGeoFilterBondValue}
                        onChangeLatLang={setisLatLangNotValid}
                        updateUnNestDataEnable={updateUnNestDataEnable}
                        vehicleName={getHeaderSignalValuesFromArray("vehicleName", data)}
                        modelYear={getHeaderValues("ModelYear", data)}
                        dispatchModelType={getHeaderValues(
                          "DispatchModelType",
                          data
                        )}
                        naOverseas={getHeaderValues("is_na", data)}
                        mapData={mapData}
                        unNestedParamData={unNestedParamData}
                        vinListFromFile={vinListFromFile}
                        plantName={getHeaderValues("plantAbbr", data)}
                        transmissionType={getHeaderValues("transmissionDescr", data)}
                        transmissionModel={getHeaderValues("transmission_model", data)}
                        engineTypeCode={getHeaderValues("engineTypeCd", data)}
                        driveTrainCategory={getHeaderValues("driveTrainDescr", data)}
                        powerTrainType={getHeaderValues("driveTrainDescr", data)}
                        engineFamilyCode={getHeaderValues('engineNm', data)}
                        partNumber={getHeaderSignalValuesFromArray('part_no', data)}
                        partName={getHeaderSignalValuesFromArray('part_desc', data)}
                        lineOffDate={getHeaderValues('line_off_date', data)}
                        campaignInd={getHeaderSignalValuesFromArray('campaign_indicator', data)}
                        campaign={getHeaderSignalValuesFromArray('campaign', data)}
                        campaignTitle={getHeaderSignalValuesFromArray('campaign_title', data)}
                        claimedPartNumber={getHeaderSignalValuesFromArray('claimed_part_no_list', data)}
                        claimedPartDescription={getHeaderValues('claimed_part_desc_list', data)}
                        t1Code={getHeaderValues('t1_cd_desc', data)}
                        t2Code={getHeaderValues('t2_cd_desc', data)}
                        fieldReportNumber={getHeaderValues('field_report_number', data)}
                        fieldReportStatus={getHeaderValues('field_report_status', data)}
                        fieldReportTitle={getHeaderValues('field_report_title', data)}
                        monthsInService={getHeaderSignalValuesFromArray('months_in_service', data)}
                        mileage={getHeaderSignalValuesFromArray('mileage', data)}
                        familyCd={getHeaderValues('familyCd', data)}
                        vehicleWarrentyIndicator={getHeaderValues('vehicleWarrentyIndicator', data)}
                        vehicleHasClaimIndicator={claimIndicatorList('claim_no', data)}
                        odometerMin={getHeaderSignalValuesFromArray('odo_min', data)}
                        odometerMax={getHeaderSignalValuesFromArray('odo_max', data)}
                      />
                    </div>
                  </div>
                  <div style={{ paddingTop: "16px", paddingBottom: "16px" }}>
                    <HeaderDatatable
                      headData={headerDataTableHeaders}
                      data={data}
                      vinList={getHeaderValues("vin", vinData)}
                    />
                  </div>
                </div>
              </div>
            )}
            {true && <Box
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"space-evenly"}
              alignItems={"center"}
            >
              <Button
                variant="contained"
                disabled={unNestDataEnable || isLatLangNotValid}
                style={{ width: "25%" }}
                onClick={() => {
                  setModalOpen(true);
                }}
              >
                Apply
              </Button>
              <Button
                variant="contained"
                style={{ width: "25%" }}
                onClick={() => {
                  navigate("/c-dad");
                }}
              >
                Cancel
              </Button>
            </Box>}
          </div>
        </Paper>
      </div>
      <Dialog
        open={modalOpen}
        onClose={() => setModalOpen(false)}
      >
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          <Typography fontWeight={'bold'}>Un-Nested Job Name</Typography>
          <IconButton
            aria-label="close"
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
            onClick={() => { setModalOpen(false); setUnnestingJobName('') }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <TextField
            variant="outlined"
            label={"Job Name"}
            placeholder={"Job Name"}
            onChange={(e) => {
              setUnnestingJobName(e.target.value);
            }}
            required
            value={unnestingJobName}
            fullWidth
            size={"small"}
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-around"}
          alignItems={"center"}
          padding={'2%'}
        >
          <Button variant='contained' disabled={unnestingJobName?.length === 0} style={{ width: '25%' }} onClick={() => { setModalOpen(false); triggerUnNestedDataJob() }}>SUBMIT</Button>
          <Button variant='contained' style={{ width: '25%' }} onClick={() => {
            setModalOpen(false);
            setUnnestingJobName('')
          }}>CLOSE</Button>
        </Box>
      </Dialog>
    </div>
  );
};

export default memo(HeadersPageRevised);
